export default __webpack_public_path__ + "static/media/management.b382e581.svg";